export default __webpack_public_path__ + "e5d5821c267c91e1af52b124f216fde9.svg";